import { ENDPOINT_PLATFORM, ENDPOINTS } from '../../constants/api'
import { madeRequest } from '../../helpers/api'
import { replaceRouteParams } from '../../helpers/url'

// PLOP_APPEND_PATTERN_ANCHOR
export function getCurrentUserService() {
  return madeRequest('GET', {
    url: ENDPOINTS.currentUserProfile
  })
}

export function submitServerLogoutService(data) {
  return madeRequest('POST', {
    data,
    url: `${ENDPOINTS.token}blacklist/` // token_blacklist_create
  })
}

export function updateCurrentUserService(userId, userData) {
  return madeRequest('PATCH', {
    data: userData,
    url: replaceRouteParams(ENDPOINTS.userSpecific, {
      id: userId
    })
  })
}

export function bannersService() {
  return madeRequest('GET', {
    url: ENDPOINTS.banners
  })
}

export function getAsyncSessionService(id, platform, params) {
  return madeRequest('GET', {
    params,
    url: replaceRouteParams(ENDPOINTS.asyncSession, {
      platform: ENDPOINT_PLATFORM[platform],
      id
    })
  })
}
